import React from "react";
var prefix = "tc-input";
export default function EyesIcon(props) {
  var show = props.show;
  var url = show ? "https://p3.8891.com.tw/nc/newcar/2022/08/23/1661243225102012.png" : "https://p3.8891.com.tw/nc/newcar/2022/08/23/1661243318517953.png";
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "__icon")
  }, /*#__PURE__*/React.createElement("img", {
    src: url,
    className: "".concat(prefix, "__icon--close")
  }));
}